import { getCachedViewSnapshotForSelections } from '@databases/database-state';
import { createPublishRovoSelectionEffect } from '@databases/rovo-bridge/selections-effect';
import { getService } from '@databases/service-container';
import { type DatabaseLayoutType } from '@databases/types/database/view';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

import { SelectionFeatureKeys, type SelectionEffectFeature } from '../../features/types';

export interface PublishRovoEffectFeatureLifecycleDeps {
  currentViewType: DatabaseLayoutType;
}

export function createPublishRovoEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.PUBLISH_ROVO_EFFECT,
    type: 'effect',
    // Always active — publishing selection state to Rovo is read-only.
    factory: () => {
      const currentView = getCachedViewSnapshotForSelections();

      return createPublishRovoSelectionEffect({
        selectionsApi: getService('SelectionsApi'),
        publishSelectionToRovo: (selection: string[]) => {
          waitForContentAPI().then((contentAPI) => {
            contentAPI?.publishDatabaseReferencingContent?.(selection);
          });
        },
        currentViewType: currentView.settings.layout.type,
      });
    },
  };
}
